import { useGetApiV1LocationStates } from '@/shared/api/generated';

/**
 * Tamanho de página usado na paginação **client-side** da listagem de Estados.
 *
 * TODO: remover a paginação client-side quando o backend implementar paginação
 * server-side em `GET /api/v1/location/states`. Hoje o endpoint retorna a lista
 * COMPLETA (sem `page`/`pageSize`/`total`), então fatiamos no front. Quando o
 * backend passar a aceitar esses parâmetros: enviar `page`/`pageSize` para
 * `useStateList`, usar `totalCount`/`totalPages` do envelope e parar de fatiar a
 * lista na página (`src/pages/_authenticated/location/states`).
 */
export const STATE_PAGE_SIZE = 10;

/**
 * Hook para listar os Estados cadastrados.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/location/states`, que retorna
 * a lista completa (sem paginação/busca server-side). Filtragem e ordenação são
 * feitas client-side na camada de UI.
 *
 * @returns Lista de estados com estado de loading/error e `refetch`.
 */
export function useStateList() {
  const query = useGetApiV1LocationStates();

  return {
    states: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
